import React, { useState } from 'react';
import { ZdsStep, ZdsStepper } from '@zig-design-system/ui-components-react';
export const Stepper = ({ steps, afterSteps, activeStep, onNavigate, erroredSteps = [] }) => {
    const [visitedSteps, setVisitedSteps] = useState([]);
    if (!(steps === null || steps === void 0 ? void 0 : steps.length) && !(afterSteps === null || afterSteps === void 0 ? void 0 : afterSteps.length)) {
        return null;
    }
    const navigate = (e) => {
        setVisitedSteps((visitedSteps) => [...visitedSteps, e.detail.step]);
        onNavigate(e.detail.step);
    };
    return (React.createElement(ZdsStepper, { onZdsStepperNavigate: navigate, className: "zds-margin-bottom-8 md:zds-margin-bottom-16", activeStep: activeStep },
        steps.map((step, index) => {
            if ((erroredSteps === null || erroredSteps === void 0 ? void 0 : erroredSteps.includes(step.uid.toString())) && !visitedSteps.includes(index)) {
                return (React.createElement(ZdsStep, { key: `step-${step.uid}`, disabled: !afterSteps, status: 'incomplete' },
                    React.createElement("span", { className: "zds-color-danger" }, step.title)));
            }
            return (React.createElement(ZdsStep, { key: `step-${step.uid}`, disabled: !afterSteps, status: index < activeStep ? 'complete' : 'unvisited' }, step.title));
        }), afterSteps === null || afterSteps === void 0 ? void 0 :
        afterSteps.map((title, index) => React.createElement(ZdsStep, { key: `step-${steps.length + index}` }, title))));
};
